import React, { useContext } from 'react'
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
  useMediaQuery,
  useTheme
} from '@mui/material'
import { Close } from '@mui/icons-material'
import { TenantsContext } from '../../context/tenants.context'

const DialogComprador: React.FC<{
  open: boolean
  setOpen: (op: boolean) => void
}> = ({ open, setOpen }) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))
  const { tenant } = useContext(TenantsContext)

  const handleClose = () => {
    setOpen(false)
  }

  const redirectComprador = () => {
    window.location.href = 'http://www.avellanedaauntoque.com/'
  }

  return (
    <Dialog open={open} onClose={handleClose} fullWidth={!isMobile}>
      <DialogTitle
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}
      >
        Usuario Comprador
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            color: (theme) => theme.palette.grey[500],
            position: 'absolute',
            right: 8,
            top: 8
          }}
        >
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ display: 'flex', flexDirection: 'column' }}>
        <Typography>
          Ingresaste un usuario que no es vendedor.
          <br />
          <br />
          Esta página web es exclusiva para vendedores de {tenant.nombrePlataforma}, pero el usuario que ingresaste no
          corresponde a una tienda.
          <br />
          <br />
          Si querés comprar, tocá el botón verde para ir al sitio web correcto.
          <br />
          Si sos vendedor, tocá el botón rojo para volver a la pantalla anterior e ingresar tus credenciales, o
          registrate si aún no lo hiciste.
        </Typography>
        <Box
          sx={{
            display: 'flex',
            flexDirection: isMobile ? 'column' : 'row',
            justifyContent: 'space-between',
            gap: '1rem',
            width: '100%',
            mt: 2
          }}
        >
          <Button variant="contained" color="error" onClick={handleClose} sx={{ width: isMobile ? '100%' : '30%' }}>
            Cancelar
          </Button>
          <Button
            variant="contained"
            color="success"
            onClick={redirectComprador}
            sx={{ width: isMobile ? '100%' : '70%' }}
          >
            Redirigir al sitio para compradores
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  )
}

export default DialogComprador
